import React from "react";
import calendarSvg from "../icons/calenderDark.svg";
import LocationSvg from "../icons/locationDark.svg";
import { dateFormater, extractTimeFromDate, formatCheckinDate, formatEventDateTime, formatEventDuration, formatTicketdate, handleOffers } from "../../../utils/util";
import dateFormat from "dateformat";

function TicketInternal(props) {
  const { data, active, payment_status } = props;
  // const amount = data?.price > 0 ? data.price * data.bookedFor : 0;
  return (
    <div className="relative event-data">
    <div className="ticket-card relative pt-32" style={{ backgroundColor: active ? "#fff" : "#424242",opacity: active ? "1" : ".8", paddingTop:"40px"}}>
      <div className="event-main-head" style={{ color: "#000" }}>{data?.eventName}</div>
      <div className="flex gap-3">
        <img className="h-fit mt-1" src={calendarSvg} alt="" />
        <div className="date-starting" style={{ fontSize: "14px", color: "#303030" }}>
          {dateFormater(data?.bookedForDate)} <span className="ml-3">({extractTimeFromDate(data?.eventDate)}-</span> <span>{extractTimeFromDate(data?.eventTo)})</span>

          <br />
          
        </div>
      </div>
     
      <div className="my-1 flex gap-3 ">
        <img className="h-fit mt-1" src={LocationSvg} alt="" />
        <div className="date-starting" style={{ fontSize: "14px", color: "#303030" }}>
          {data?.hotelName}
        </div>
      </div>
      <div className="mt-2">
          <div className="payment-status-success ml-6" style={{opacity: active? "1": ".4"}}>{data?.status}</div>
      </div>
      
      <div className="flex items-center justify-between">
        <div className="h-6 w-6 bg-[#0C0C1F] rounded-full -ml-7"></div>
        <div
          className="w-full border-t-2 border-separate border-dashed border-gray-400"
          style={{ borderColor: active ? "#CACACA" : "#5d5c5c" }}
        ></div>
        <div className="h-6 w-6 rounded-full bg-[#0C0C1F] -mr-7"></div>
      </div>
      <div className="ref-no flex flex-col items-center justify-center mb-2 text-left">
        <div>
          {data?.bookedFor} {data?.bookedFor > 1 ? "Tickets" : "Ticket"}
        </div>
        <div>
        {data?.price > 0 ? `₹ ${data?.price}` : "Free/-"}
        </div>
       <div className="mt-1">Booking ID: {data?.bookingRefNo}</div> 
      </div>
      <div className="text-xs absolute top-3 right-3" style={{color:"gray", fontWeight:"500"}}>{formatTicketdate(data?.time)}</div>

    </div>
    {!active && <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pt-4 text-white font-semibold text-md">Ticket Expired</div>}

    </div>
  );
}

export default TicketInternal;
